import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import {
  AddToQueue,
  CorporateFare,
  DevicesRounded,
  ImportExport,
  LocalOffer,
  MeetingRoom,
  Monitor,
  PostAdd,
  Redeem,
  VpnKey,
  Sensors,
  People,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function MenuContent({ collapsed }) {
  const navigate = useNavigate();

  const { t } = useTranslation("common");

  const adminMenuItems = [
    {
      text: t("common.dashboard"),
      icon: <HomeRoundedIcon />,
      url: "/",
    },
    {
      text: t("common.devices"),
      icon: <DevicesRounded />,
      url: "/devices",
    },
    {
      text: t("common.screens"),
      icon: <Monitor />,
      url: "/screens",
    },
    {
      text: "Appairer un écran",
      icon: <AddToQueue />,
      url: "/pair-screen",
    },
    {
      text: t("common.packs"),
      icon: <Redeem />,
      url: "/packs",
    },
    { text: t("common.brands"), icon: <LocalOffer />, url: "/brands" },
    {
      text: t("common.establishments"),
      icon: <CorporateFare />,
      url: "/establishments",
    },
    {
      text: t("common.residences"),
      icon: <MeetingRoom />,
      url: "/residences",
    },
    {
      text: t("common.export"),
      icon: <ImportExport />,
      url: "/export",
    },
    {
      text: "API Keys",
      icon: <VpnKey />,
      url: "/api-keys",
    },
    {
      text: "Capteurs",
      icon: <Sensors />,
      url: "/admin/device-brands",
    },
    {
      text: "Utilisateurs",
      icon: <People />,
      url: "/admin/users",
    },
  ];

  const userMenuItems = [
    {
      text: t("common.dashboard"),
      icon: <HomeRoundedIcon />,
      url: "/",
    },
    {
      text: "Appairer un écran",
      icon: <AddToQueue />,
      url: "/pair-screen",
    },
    {
      text: t("common.export"),
      icon: <ImportExport />,
      url: "/export",
    },
  ];

  const secondaryListItems = [
    {
      text: t("common.settings"),
      icon: <SettingsRoundedIcon />,
      url: "/settings",
    },
    {
      text: t("common.import"),
      icon: <PostAdd />,
      url: "/import",
    },
  ];

  const userDB = useSelector((state) => state.userDB);

  const isAdmin = userDB ? userDB.admin : false;

  const menuItems = isAdmin ? adminMenuItems : userMenuItems;

  const renderMenuItem = (item, index) => (
    <ListItem
      key={index}
      disablePadding
      sx={{ display: "block" }}
      onClick={() => navigate(item.url)}
    >
      <Tooltip title={collapsed ? item.text : ""} placement="right">
        <ListItemButton
          selected={window.location.pathname === item.url}
          sx={{
            minHeight: 48,
            justifyContent: collapsed ? "center" : "initial",
            px: collapsed ? 1 : 2.5,
            color: "var(--text-primary)",
            borderRadius: "8px",
            position: "relative",
            "&.Mui-selected": {
              backgroundColor: "var(--menu-selected-bg)",
              color: "var(--menu-selected-fg)",
              fontWeight: 600,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 8,
                bottom: 8,
                width: 3,
                borderRadius: 2,
                background: "var(--menu-selected-bar)",
              },
              "&:hover": {
                backgroundColor: "var(--menu-selected-hover-bg)",
              },
              "& .MuiListItemIcon-root": {
                color: "var(--menu-selected-fg)",
              },
            },
            "&:hover": {
              backgroundColor: "var(--menu-item-hover)",
            }
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: collapsed ? 0 : 3,
              justifyContent: "center",
            }}
          >
            {item.icon}
          </ListItemIcon>
          {!collapsed && <ListItemText primary={item.text} />}
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
      <List dense>
        {menuItems.map((item, index) => renderMenuItem(item, index))}
      </List>

      <List dense>
        {secondaryListItems.map((item, index) =>
          index > 0 && !isAdmin ? null : renderMenuItem(item, index)
        )}
      </List>
    </Stack>
  );
}
